export default __webpack_public_path__ + "static/media/dev2.7964cd92.png";